import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, Injector, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MasterService } from '../../../../../../../services/master.service'
import { MessageService } from '../../../../../../../services/message.service'
import * as languageLibrary from '../../../../../../../services/language'
import { SEARCH_DEBOUNCE_MILLIS, MIN_SEARCH_CHARS } from 'src/app/constants/list';
import { RELATIONSHIP_TYPES } from 'src/app/constants/contact';
import { token } from '../../roles.component';
import { DynamicService } from 'src/app/services/dynamic.service';
import { Contact } from 'src/app/models/contact.model';
import { ListHeader } from 'src/app/models/list-header.model';
import { RelationshipType } from 'src/app/models/relationship-type.model';
import { Relationship } from 'src/app/models/relationship.model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'references',
    templateUrl: './references.component.html',
    styleUrls: ['./references.component.scss'],
    standalone: false
})

export class ReferencesComponent implements OnInit, OnDestroy {

    @Input() contactId: number = 0
    
    protected words = languageLibrary.language
    
    protected language: string = 'EN'
    
    // table headers
    public headers: ListHeader[] = [
        { name: 'firstName', param: 'firstName', view: null, disabled: null },
        { name: 'lastName', param: 'lastName', view: null, disabled: null },
        { name: 'relationship', param: 'relationship', view: null, disabled: null },
        { name: 'startDate', param: 'start', view: null, disabled: null },
        { name: 'endDate', param: 'end', view: null, disabled: null },
        { name: 'duration', param: 'duration', view: null, disabled: null },
        { name: 'phoneNumber', param: 'phoneNumber', view: null, disabled: null },
        { name: 'emailAddress', param: 'emailAddress', view: null, disabled: null },
        { name: 'actions', param: null, view: null, disabled: null }
    ]
    
    public relationshipTypes: RelationshipType[] = RELATIONSHIP_TYPES
    
    public relationshipList: Relationship[] = []
    
    public relationshipId: number | null = null
    
    protected loading: boolean = false
    
    public viewDetail: boolean = false
    
    private timeOutID: any;
    
    public contactList: Contact[] = []
    
    public contactSelected: Contact | null = null

    // reference selected
    public isContactSelected: boolean = false

    // The current contact search inquiry
    public inquiry: string | null = null

    public auxContact: Contact = new Contact()
    
    // Indicates the system is already checking for matching contacts.
    public searching: boolean = false

    // Indicates the system won't be able to find any more 
    // mathcing contacts. The last list received was already empty.
    public exhausted: boolean = false

    protected dataIn: string;
    
    // Group of inputs
    public form = new FormGroup({
        fromContactId: new FormControl<number>(0),
        firstName: new FormControl<string | null>(null, [Validators.required]),
        lastName: new FormControl<string | null>(null, [Validators.required]),
        relationship: new FormControl<string | null>(null, [Validators.required]),
        startDate: new FormControl<string>(new Date().toISOString().substring(0, 10)),
        endDate: new FormControl<string>(new Date().toISOString().substring(0, 10)),
        phoneNumber: new FormControl<string | null>(null),
        emailAddress: new FormControl<string | null>(null)
    }, {
        validators: Validators.compose([this.dateLessThan('startDate', 'endDate')])
    })

    private subscriptions: Subscription[] = []

    // get information of inputs
    get firstName() { return this.form.get('firstName') }
    get lastName() { return this.form.get('lastName') }
    get relation() { return this.form.get('relation') }
    // get relationshipTypeId() { return this.form.get('relationshipTypeId') }
    get start() { return this.form.get('startDate') }
    get end() { return this.form.get('endDate') }
    get phoneNumber() { return this.form.get('phoneNumber') }
    get emailAddress() { return this.form.get('emailAddress') }

    /*
    * functions
    */

    constructor(private master: MasterService, private ms: MessageService, private inject: Injector, private serv: DynamicService) {
        this.watchFirstName()
    }

    ngOnInit() {
        this.reset()
        this.dataIn = this.inject.get(token);
        this.contactId = this.dataIn['contactId']

        if (!this.contactId) {
            return
        }

        this.readRelationships()
    }

    public dateLessThan(startDate: string, endDate: string) {
        return (group: FormGroup): { [key: string]: any } => {
            let start = group.controls[startDate];
            let end = group.controls[endDate];
            if (end.value !== '') {
                if (start.value > end.value) {
                    return {
                        dates: "Date from should be less than Date to"
                    };
                }
                return
            }
            return {};
        }
    }

    /** Contact was modified in the modal */ 
    public modified = (e): void => {
        this.readRelationships()
    }


    // todo:get data for contact selected
    public getContactRelationshipDetail = (relationship: Object, openDetail: boolean) => {
        this.loading = true
        this.master.get(`contacts/${relationship['fromContactId']}`, res => {
            this.loading = false
            this.viewDetail = true

            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }
            this.auxContact = res.data.contact

            setTimeout(() => {
                const btn = (document.getElementById('editContactModalBtn') as HTMLButtonElement)
                if (btn) {
                    btn.click()
                }
            }, 100)
        })
    }

    // clean Fields
    protected reset = (): void => {
        this.form.reset()
        this.form.get('firstName').enable()
        this.form.get('lastName').enable()
        this.form.get('phoneNumber').enable()
        this.form.get('emailAddress').enable()
        this.contactList = []
        this.contactSelected = null
        this.isContactSelected = false
        this.exhausted = false
        this.searching = false
        this.inquiry = null
        this.loading = false
    }

    public createContact = (closeAfter) => {
        this.master.post(`contacts/${this.contactId}/relationships`, this.form.value, res => {
            if (!res) {
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.readRelationships()
            const btn = (document.getElementById('btn-cancel-references-new') as HTMLButtonElement)
            if (btn && closeAfter) {
                btn.click()
            }

            this.reset()
        })
    }

    public setRelationship = (relationship: Object, action: string): void => {
        this.relationshipId = parseInt(relationship['id'])
        this.reset()

        if (action.toLowerCase() !== 'modify') {
            return
        }

        this.form.get('firstName').disable()
        this.form.get('lastName').disable()
        this.form.get('phoneNumber').disable()
        this.form.get('emailAddress').disable()
        this.form.patchValue({
            fromContactId: relationship['id'],
            firstName: relationship['firstName'],
            lastName: relationship['lastName'],
            relationship: relationship['relationship'],
            startDate: relationship['started'],
            endDate: relationship['ended'],
            phoneNumber: relationship['phone'],
            emailAddress: relationship['comms']
        })
    }


    // delete reference
    public discard = (): void => {
        this.loading = true
        this.master.discard(`contacts/${this.contactId}/relationships/${this.relationshipId}`, res => {
            this.loading = false
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.readRelationships()

            let btn = (document.getElementById('close-delete-modal-reference') as HTMLButtonElement)
            if (btn) {
                btn.click()
            }
        })
    }

    public update = (): void => {
        if (this.form.invalid) {
            return
        }

        const id = this.relationshipId
        if (!id || isNaN(id) || (id <= 0)) {
            return
        }

        this.loading = true
        const payload = this.form.value
        delete (payload.relationship)
        this.master.put(`contacts/${this.contactId}/relationships/${this.relationshipId}`, payload, res => {
            this.loading = false

            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.readRelationships()
            let btn = (document.getElementById('close-update-modal-reference') as HTMLButtonElement)
            if (btn) {
                btn.click()
            }
        })
    }

    /**
    * Verify if the contact already exists
    */
    public contactExists(): void {
        this.contactList = []
        this.master.get(`readForDuplicateContact?firstName=${this.inquiry}`, (res: { status: number; data: { contacts: Contact[]; }; }) => {
            this.searching = false

            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                return
            }

            this.contactList = res.data.contacts
            this.exhausted = (this.contactList.length <= 0)
        })
    }

    /**
    * An existing contact was chosen from the data list
    * @param contact The existing contact metda data chosen from the data list.
    */
    public selectContact = (contact: Contact) => {
        if (!contact) {
            return
        }

        this.contactSelected = contact
        this.isContactSelected = true

        this.firstName.setValue(contact['firstName'])
        this.lastName.setValue(contact['lastName'])
    }

    private readRelationships = (): void => {
        this.master.get(`contacts/${this.contactId}/relationships`, (res: { status: number; data: { error: any; relationships: []; }; }) => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }
            this.relationshipList = res.data.relationships
        })
    }

    private watchFirstName = () => {
        this.subscriptions.push(
            this.firstName.valueChanges.subscribe(name => {
                if (this.timeOutID) {
                    clearTimeout(this.timeOutID)
                }

                if (this.isContactSelected) {
                    return
                }

                if (!name || (name.length < MIN_SEARCH_CHARS)) {
                    this.exhausted = false
                    return
                }

                if (this.inquiry && (!name.startsWith(this.inquiry))) {
                    this.exhausted = false
                }

                if (this.searching || this.exhausted) {
                    return
                }

                this.timeOutID = setTimeout(() => {
                    this.inquiry = name
                    this.searching = true
                    // this.contactExists()
                }, SEARCH_DEBOUNCE_MILLIS)
            })
        )
    }

    ngOnDestroy() {
        for (const sub of this.subscriptions) {
            sub.unsubscribe()
        }
    }
}
